import RpcClass from "../../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.plm.services.SupplierService';

import LocalDate from "../../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../../server/LocalTime.js";



class SupplierService extends RpcClass{

    /**
     *  @class SupplierService
     *  @alias module:src/server/com/silkplm/rpc/plm/services/SupplierService.SupplierService
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     checkIfListOfContractorAttributeIsActive() {
            return RpcClass.rpcCall('/rpc/plm/services/supplier-service/check-if-list-of-contractor-attribute-is-active', []);
    }
    /** 
     * @async
     * @param name {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/dictionaries/Country.Country>}
     */
     findCountryByName(name) {
            return RpcClass.rpcCall('/rpc/plm/services/supplier-service/find-country-by-name', [name]);
    }
    /** 
     * @async
     * @param name {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/dictionaries/Port.Port>}
     */
     findShipmentPortByName(name) {
            return RpcClass.rpcCall('/rpc/plm/services/supplier-service/find-shipment-port-by-name', [name]);
    }
    /** 
     * @async
     * @param name {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/Suppliers.Suppliers>}
     */
     findSupplierByName(name) {
            return RpcClass.rpcCall('/rpc/plm/services/supplier-service/find-supplier-by-name', [name]);
    }
    /** 
     * @async
     * @param taxID {string} 
     * @param clazz {string} 
     * @param eid {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     replaceDataWithDataFromCEIDGByTaxId(taxID, clazz, eid) {
            return RpcClass.rpcCall('/rpc/plm/services/supplier-service/replace-data-with-data-from-c-e-i-d-g-by-tax-id', [taxID, clazz, eid]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.plm.services.SupplierService';
metadata.__type_short__ = 'SupplierService';
SupplierService.prototype.__metadata__ = metadata;

SupplierService.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/plm/services/SupplierService */
export default SupplierService

export { SupplierService }
